import * as Yup from "yup";

const getMaxLengthMessage = (fieldName: string, maxLength: number): string => `${fieldName} can't be longer than ${maxLength} symbols`;
const getRequiredMessage = (fieldName: string): string => `Please enter ${fieldName}`;

export default Yup.object({
    firstName: Yup
        .string()
        .max(20, ({ max}) => getMaxLengthMessage('Contact First Name', max))
        .required(getRequiredMessage('Contact First Name')),
    lastName: Yup
        .string()
        .max(20, ({ max}) => getMaxLengthMessage('Contact Last Name', max))
        .required(getRequiredMessage('Contact Last Name')),
    email: Yup
        .string()
        .email("Invalid email format")
        .max(100, ({ max}) => getMaxLengthMessage('Contact Email Address', max))
        .required(getRequiredMessage('Contact Email Address')),
    phone: Yup
        .string()
        .max(20, ({ max}) => getMaxLengthMessage('Contact Phone Number', max))
        .required(getRequiredMessage('Contact Phone Number')),
    company: Yup.object({
        name: Yup
            .string()
            .max(100, ({ max}) => getMaxLengthMessage('Company Name', max))
            .required(getRequiredMessage('Company Name')),
        businessType: Yup
            .string()
            .required(getRequiredMessage('Company Business Type')),
        machineApplication: Yup
            .string()
            .required(getRequiredMessage('Company Machine Application')),
    }),
});
